export default __webpack_public_path__ + "media/src/assets/images/Download-859178abdbe69960e032bff3b4194acc.svg";